import { GetterTree } from 'vuex';
import { State } from '@/plugins/store/state';

const gettersObject = {};

/* Boilerplate for type safety */
export type Getters = typeof gettersObject;
export const getters: GetterTree<State, State> & Getters = {};
